import { Link } from '../../../../../../../shared/frontend/components/link';
import { t } from 'i18next';
import NewsListLoader from '../news/newsListLoader';
import NewsListContent from '../news/newsListContentFrontpage';

export function NewsSection(props: any) {
  return (
    <>
      <div className="slds-m-bottom--small slds-m-top--large rio-m-top-mobi--small slds-grid slds-grid--align-spread slds-grid--vertical-align-end">
        <div className="slds-col">
          <h2 className="rio-text-title--caps text-raiderio">
            <Link to="/news">{t('frontpage:featured-news')}</Link>
          </h2>
        </div>
        <div className="slds-col">
          <Link to="/news">{t('frontpage:read-all-news')}</Link>
        </div>
      </div>

      <NewsListLoader maxPerRow={5} limit={props.max} mobileLimit={3} mode="featured" component={NewsListContent} />
    </>
  );
}
